<div *ngIf="hero as hero" [ngClass]="{ 'dark': darkMode, 'is-disabled': disabled, cardInfoStyle }" class="card reputation-status-card"
    [ngStyle]="{ '--status-accent': hero.accentColor, '--status-accent-glow': hero.accentGlow }" role="button"
    [attr.tabindex]="disabled ? -1 : 0" [attr.aria-disabled]="disabled" (click)="onCardClick()"
    (keydown.enter)="onCardClick()" (keydown.space)="onCardSpace($event)">
    <div class="reputation-status-card__hero">
        <div class="reputation-status-card__hero-content">
            <div class="reputation-status-card__hero-copy">
                <p class="reputation-status-card__eyebrow">{{ 'REPUTATION_STATUS_TITLE' | translate }}</p>
                <p class="reputation-status-card__level">{{ hero.currentTitle }}</p>
                <p *ngIf="!hero.isFinalLevel; else reputationFinalCopy" class="reputation-status-card__message">
                    {{ 'REPUTATION_STATUS_SUBTITLE' | translate:{ level: hero.nextLevelTitle } }}
                </p>
                <ng-template #reputationFinalCopy>
                    <p class="reputation-status-card__message">{{ 'REPUTATION_STATUS_FINAL' | translate }}</p>
                </ng-template>
            </div>

            <div class="reputation-status-card__badge" aria-hidden="true">
                <div class="reputation-status-card__badge-shell">
                    <div class="reputation-status-card__badge-core">
                        <img *ngIf="hero.currentIconUrl; else currentHeroFallback" [src]="hero.currentIconUrl"
                            [alt]="hero.currentTitle">
                        <ng-template #currentHeroFallback>
                            <span class="reputation-status-card__badge-fallback">
                                {{ hero.currentTitle | slice:0:1 }}
                            </span>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="reputation-status-card__body box">
        <div class="reputation-status-card__meta">
            <p *ngIf="!hero.isFinalLevel; else reputationGoalReached" class="reputation-status-card__target">
                <span>{{ hero.remainingPointsText }}</span>
                <img class="reputation-status-card__points-icon" [src]="hero.pointsIconUrl" alt="" aria-hidden="true">
                <span>{{ 'REPUTATION_STATUS_TO_LEVEL' | translate:{ level: hero.nextLevelTitle } }}</span>
            </p>
            <ng-template #reputationGoalReached>
                <p class="reputation-status-card__target">{{ 'CONGRATULATION' | translate }}</p>
            </ng-template>

            <p class="reputation-status-card__ratio">
                <span class="reputation-status-card__ratio-group">
                    <span class="reputation-status-card__ratio-value">{{ hero.currentPointsText }}</span>
                    <img class="reputation-status-card__points-icon" [src]="hero.pointsIconUrl" alt=""
                        aria-hidden="true">
                </span>
                <span class="reputation-status-card__ratio-separator">/</span>
                <span class="reputation-status-card__ratio-group">
                    <span class="reputation-status-card__ratio-value">{{ hero.goalPointsText }}</span>
                    <img class="reputation-status-card__points-icon" [src]="hero.pointsIconUrl" alt=""
                        aria-hidden="true">
                </span>
            </p>
        </div>

        <div class="reputation-status-card__bar">
            <div class="reputation-status-card__bar-fill" [style.background]="hero.accentColor"
                [style.width.%]="hero.progress"></div>
            <span class="reputation-status-card__bar-knob" [style.left.%]="hero.progress"></span>
        </div>

        <div class="reputation-status-card__milestones-shell">
            <div class="reputation-status-card__milestones" [class.has-single-node]="hero.milestones.length < 2"
                [style.gridTemplateColumns]="'repeat(' + hero.milestones.length + ', minmax(78px, 1fr))'">
                <div *ngFor="let milestone of hero.milestones; trackBy: trackReputationMilestone"
                    class="reputation-status-card__milestone" [class.state-current]="milestone.state === 'current'"
                    [class.state-reached]="milestone.state === 'reached'"
                    [class.state-upcoming]="milestone.state === 'upcoming'">
                    <span class="reputation-status-card__milestone-dot"></span>

                    <div class="reputation-status-card__milestone-inner">
                        <div class="reputation-status-card__milestone-icon"
                            [style.borderColor]="milestone.state !== 'current' ? milestone.color : null">
                            <img class="border-24" *ngIf="milestone.iconUrl; else milestoneFallback" [src]="milestone.iconUrl"
                                [alt]="milestone.title">
                            <ng-template #milestoneFallback>
                                <span class="reputation-status-card__milestone-fallback">
                                    {{ milestone.title | slice:0:1 }}
                                </span>
                            </ng-template>

                            <span *ngIf="milestone.isLocked" class="reputation-status-card__milestone-lock"
                                aria-hidden="true">
                                <svg width="14" height="14" viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <path
                                            d="M17 10.25H16.75V8C16.75 6.74022 16.2496 5.53204 15.3588 4.64124C14.468 3.75045 13.2598 3.25 12 3.25C10.7402 3.25 9.53204 3.75045 8.64124 4.64124C7.75045 5.53204 7.25 6.74022 7.25 8V10.25H7C6.27065 10.25 5.57118 10.5397 5.05546 11.0555C4.53973 11.5712 4.25 12.2707 4.25 13V18C4.25 18.7293 4.53973 19.4288 5.05546 19.9445C5.57118 20.4603 6.27065 20.75 7 20.75H17C17.7293 20.75 18.4288 20.4603 18.9445 19.9445C19.4603 19.4288 19.75 18.7293 19.75 18V13C19.75 12.2707 19.4603 11.5712 18.9445 11.0555C18.4288 10.5397 17.7293 10.25 17 10.25ZM8.75 8C8.75 7.13805 9.09241 6.3114 9.7019 5.7019C10.3114 5.09241 11.138 4.75 12 4.75C12.862 4.75 13.6886 5.09241 14.2981 5.7019C14.9076 6.3114 15.25 7.13805 15.25 8V10.25H8.75V8ZM18.25 18C18.25 18.3315 18.1183 18.6495 17.8839 18.8839C17.6495 19.1183 17.3315 19.25 17 19.25H7C6.66848 19.25 6.35054 19.1183 6.11612 18.8839C5.8817 18.6495 5.75 18.3315 5.75 18V13C5.75 12.6685 5.8817 12.3505 6.11612 12.1161C6.35054 11.8817 6.66848 11.75 7 11.75H17C17.3315 11.75 17.6495 11.8817 17.8839 12.1161C18.1183 12.3505 18.25 12.6685 18.25 13V18Z"
                                            [attr.fill]="!darkMode ? '#000000' : '#ffffff'"></path>
                                    </g>
                                </svg>
                            </span>
                        </div>
                    </div>

                    <p class="reputation-status-card__milestone-title">{{ milestone.title }}</p>
                    <p class="reputation-status-card__milestone-points">
                        <span>{{ milestone.pointsLabel }}</span>
                        <img class="reputation-status-card__points-icon" [src]="hero.pointsIconUrl" alt=""
                            aria-hidden="true">
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>